import { useContainer } from '../../useContainer';
import { ProjectApi, ToastStateHandler } from '../../../api';
import { useTranslation } from '../../useTranslation';
import { ICallback } from '../../../commonTypes/hook.types';
import { AppError, isErrorCode, getUserMessage } from '../../../api/utils/ErrorHandler';
import { ErrorCodes } from '../../../api/utils/errorCodes';

const useHttpDeleteProjectAssignee = () => {
    const projectApi: ProjectApi = useContainer(ProjectApi);
    const toastHandler = useContainer(ToastStateHandler);
    const { t } = useTranslation('newNotifications');

    const execDelete = (userSub: string, projectId: string, callback: ICallback) => {
        const { exec, abort } = projectApi.deleteProjectAssignee({
            params: { userSub, id: projectId },
            onSuccess: _ => {
                toastHandler.push('success', t('projects.deleteAssigneeTitle'), t('projects.deleteAssigneMessage_Success'));
                if (callback.onSuccess) callback.onSuccess();
            },
            onError: (error: AppError | string) => {
                // Support both new and legacy error codes for backward compatibility
                if (isErrorCode(error, ErrorCodes.LAST_MANAGER_DELETION) || isErrorCode(error, ErrorCodes.LAST_PROJECT_MANAGER)) {
                    toastHandler.push('error', t('projects.deleteAssigneeTitle'), t('projects.deleteAssigneMessage_FailedLastManager'));
                } else if (
                    isErrorCode(error, ErrorCodes.PROJECT_ACCESS_DENIED) ||
                    isErrorCode(error, ErrorCodes.PROJECT_ACCESS_FORBIDDEN) ||
                    isErrorCode(error, ErrorCodes.INSUFFICIENT_PERMISSIONS)
                ) {
                    toastHandler.push('error', t('projects.deleteAssigneeTitle'), t('projects.deleteAssigneMessage_FailedNoPesmission'));
                } else {
                    // Use backend userMessage
                    const message = getUserMessage(error);
                    toastHandler.push('error', t('projects.deleteAssigneeTitle'), message);
                }
            },
        });
        exec();
        return abort;
    };

    return { execDelete };
};

export default useHttpDeleteProjectAssignee;
